module.exports = __webpack_public_path__ + "img/gluten.1b4b423d.png";